import { render, staticRenderFns } from "./c_upload_video.vue?vue&type=template&id=1fcb908a&scoped=true"
import script from "./c_upload_video.vue?vue&type=script&lang=js"
export * from "./c_upload_video.vue?vue&type=script&lang=js"
import style0 from "./c_upload_video.vue?vue&type=style&index=0&id=1fcb908a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcb908a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcb908a')) {
      api.createRecord('1fcb908a', component.options)
    } else {
      api.reload('1fcb908a', component.options)
    }
    module.hot.accept("./c_upload_video.vue?vue&type=template&id=1fcb908a&scoped=true", function () {
      api.rerender('1fcb908a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_upload_video.vue"
export default component.exports